import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'team';

const base =
  'inline-flex min-h-touch items-center justify-center gap-2 rounded-2xl px-5 font-semibold ' +
  'transition-transform active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-45';

const variants: Record<Variant, string> = {
  primary: 'bg-accent text-accent-ink',
  secondary: 'border border-line bg-surface-2 text-fg',
  ghost: 'text-muted underline underline-offset-4',
  // Uses the --team / --team-ink variables set by teamStyle().
  team: 'bg-[rgb(var(--team))] text-[rgb(var(--team-ink))] font-display text-3xl font-bold shadow-[inset_0_0_0_1px_rgb(var(--hs-fg)/0.15)]',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
}

export function Button({
  variant = 'secondary',
  block = false,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`${base} ${variants[variant]} ${block ? 'w-full' : ''} ${className}`}
      {...rest}
    />
  );
}
